// extracted by mini-css-extract-plugin
export default {"mapEl":"CommerceDeliveryMap_mapEl__-BI0f","mapLoading":"CommerceDeliveryMap_mapLoading__Asztk","mapFallback":"CommerceDeliveryMap_mapFallback__LBH+7"};